export default {"src":"/_next/static/media/cybus.4c57086e.svg","height":30,"width":106,"blurWidth":0,"blurHeight":0};